// How long an unanswered inbound ring may keep announcing itself. Bounds both
// the looping ringtone and the notification shown when the browser refuses to
// play that ringtone, so the two can never disagree.
export const RING_ANNOUNCEMENT_MS = 60 * 1000

// Copy for the fallback channels used when the ringtone itself is not audible.
// Kept together so the desktop notification and the tab-title cue always say the
// same thing to the agent.
export const RING_ANNOUNCEMENT_TITLE = 'Incoming Call'

export const RING_UNKNOWN_CALLER = 'Unknown caller'

export const RING_NOTIFICATION_TAG = 'reservation-ringtone-blocked'

// Tab-title cue shown when neither the ringtone nor a desktop notification is
// available.
export const RING_TITLE_CUE = `📞 ${RING_ANNOUNCEMENT_TITLE}`

export const RING_TITLE_CUE_INTERVAL_MS = 1000
